import Link from 'next/link';
import React from 'react';

interface IProps {
  className?: string;
  children: React.ReactNode;
  title: React.ReactNode | string;
  titleHref?: string;
  seeAll?: string;
}

export const LinksBlock: React.FC<IProps> = ({ className, title, titleHref, seeAll, children }) => (
  <div className={`flex w-full flex-col text-center md:w-[242px] md:text-left ${className}`}>
    <h3 className='mb-3 text-2xl font-bold text-neutral-800 underline'>
      {titleHref ? (
        <Link className='cursor-pointer hover:text-neutral-500' href={titleHref}>
          {title}
        </Link>
      ) : (
        title
      )}
    </h3>
    <ul className='flex cursor-pointer flex-col gap-3 text-lg font-normal leading-normal text-neutral-500 underline underline-offset-2 [&>a:hover]:text-neutral-700'>
      {children}
    </ul>
    {seeAll && titleHref && (
      <Link
        className='mt-5 cursor-pointer pt-2 align-middle text-base font-semibold text-neutral-800 hover:text-neutral-800'
        href={titleHref}>
        {seeAll}
        <i className='fas fa-chevron-right ml-4' />
      </Link>
    )}
  </div>
);
